import { useStore } from "@/context/StoreContext";
import { buildWhatsAppUrl } from "@/lib/helpers";
import { api } from "@/lib/api";

const WA_ICON =
  "M19.11 17.2c-.28-.14-1.63-.8-1.88-.89-.25-.09-.44-.14-.62.14-.18.28-.71.89-.87 1.07-.16.18-.32.2-.6.07-.28-.14-1.17-.43-2.23-1.38-.82-.73-1.38-1.64-1.54-1.92-.16-.28-.02-.43.12-.57.13-.13.28-.32.42-.48.14-.16.18-.28.28-.46.09-.18.05-.35-.02-.49-.07-.14-.62-1.5-.85-2.05-.22-.53-.45-.46-.62-.47l-.53-.01c-.18 0-.48.07-.73.35-.25.28-.96.94-.96 2.29s.98 2.66 1.12 2.84c.14.18 1.93 2.95 4.68 4.14.65.28 1.16.45 1.56.58.66.21 1.25.18 1.72.11.53-.08 1.63-.67 1.86-1.31.23-.64.23-1.19.16-1.31-.07-.12-.25-.19-.53-.33M16.05 26.5h-.01c-1.74 0-3.44-.47-4.93-1.35l-.35-.21-3.67.96.98-3.58-.23-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.89 9.9-9.89 2.64 0 5.13 1.03 7 2.9a9.83 9.83 0 0 1 2.9 7c0 5.45-4.44 9.89-9.89 9.89m8.42-18.3A11.8 11.8 0 0 0 16.05 4.7C9.52 4.7 4.2 10.02 4.2 16.55c0 2.09.55 4.13 1.58 5.93L4.1 28.4l6.06-1.59a11.83 11.83 0 0 0 5.66 1.44h.01c6.53 0 11.85-5.32 11.85-11.85 0-3.17-1.23-6.14-3.47-8.38";

export default function FloatingWhatsApp() {
  const { settings } = useStore();
  if (!settings?.whatsapp_number) return null;

  const handleClick = () => {
    const text = `Halo Admin ${settings.store_name}, saya mau bertanya tentang produk di katalog UPPLESORIES.`;
    api.post("/track/whatsapp-click", { product_id: "floating" }).catch(() => {});
    window.open(buildWhatsAppUrl(settings.whatsapp_number, text), "_blank");
  };

  return (
    <button
      data-testid="floating-whatsapp-btn"
      onClick={handleClick}
      aria-label="Chat WhatsApp"
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-whatsapp text-white shadow-lg shadow-emerald-500/30 transition-transform duration-300 hover:scale-110 active:scale-95"
    >
      <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" />
      <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-current">
        <path d={WA_ICON} />
      </svg>
    </button>
  );
}
